import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row } from 'reactstrap';
import { EmailInput, Icon, ToogleSwitch } from 'tacho-ui';
import { defaultRegisterUserModel, RegisterUserModel } from '../../../core/domainModels/users/UsersModel';
import { ApplicationState } from '../../../state/ApplicationState';
import { DispatchType } from '../../../state/configureStore';
import { addUserThunk, fetchUsersThunk } from '../../../state/users/reducer';
import { TachoModal } from '../../components/TachoModal';
import { TachoEditModalTitle } from '../../components/TachoModal/TachoEditTitle';
interface AddUserModalProps {
    isOpen: boolean;
    onToggle: () => void;
}
export const AddUserModal = (props: AddUserModalProps) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch<DispatchType>();
    const [userData, setUserData] = useState<RegisterUserModel>(defaultRegisterUserModel);
    const onSubmit = () => {
        dispatch(addUserThunk(userData))
            .unwrap()
            .then(success => {
                if (success) {
                    dispatch(fetchUsersThunk());
                    setUserData(defaultRegisterUserModel);
                    props.onToggle();
                }
            })
            .catch(err => console.log(err));
    };
    const addUserPending = useSelector((state: ApplicationState) => state.users.addUsersPending);
    const addUserError = useSelector((state: ApplicationState) => state.users.addUsersError);
    return (
        <TachoModal
            size={'md'}
            height={'auto'}
            isOpen={props.isOpen}
            onToggle={() => {
                setUserData(defaultRegisterUserModel);
                props.onToggle();
            }}
            onSubmit={onSubmit}
            title={<TachoEditModalTitle titleToTranslation="usersAddUser" icon={Icon.User} />}
            submitLabelToTranslate="commonAdd"
            submitIcon={Icon.Add}
            isPending={addUserPending}
            errorToTranslate={addUserError}
        >
            <Container fluid className="d-flex flex-column px-4 gap-3">
                <Row>
                    <EmailInput
                        label={formatMessage({ id: 'usersEmail' })}
                        value={userData?.email}
                        onChange={value => setUserData({ ...userData, email: value })}
                    />{' '}
                </Row>
                <Row>
                    <ToogleSwitch
                        label={formatMessage({ id: 'usersSendVerificationEmail' })}
                        value={userData?.sendAccountCreationConfirmationEmail}
                        onChange={value => setUserData({ ...userData, sendAccountCreationConfirmationEmail: value })}
                    />
                </Row>
            </Container>
        </TachoModal>
    );
};
